
























import { Component, Vue, Watch } from "vue-property-decorator";
import shuffle from "lodash/shuffle";
import KarutaPlayerEnglish from "@/components/KarutaPlayerEnglish.vue";
import FooterUI from "@/components/FooterUI.vue";
import VueRouter from "vue-router";
import Sounds from "@/components/Sounds.vue";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  components: {
    KarutaPlayerEnglish,
    "footer-ui": FooterUI,
    Sounds,
  },
})
export default class GameEnglish extends Vue {
  $refs!: {
    player: KarutaPlayerEnglish;
    bgm: HTMLAudioElement;
    se: HTMLAudioElement;
    footer: FooterUI;
    sounds: Sounds;
  };
  karutaData = [
    {
      ...this.createKarutaProperty(1),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_01-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(2),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_02-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(3),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_03-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(4),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_04-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(5),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_05-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(6),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_06-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(7),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_07-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(8),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_08-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(9),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_09-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(10),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_10-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(11),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_11-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
    {
      ...this.createKarutaProperty(12),
      characters: [
        {
          ...this.createStyle("/sekisuikaruta/game/img/chara/yomi_img_12-03.png", 707, {
            right: "4%",
            top: "10%",
          }),
          animation: {
            from: { opacity: 0, translateX: 100 },
            to: { opacity: 1, translateX: 0, duration: 1 },
          },
        },
      ],
    },
  ];

  playing = false;
  state = "READY";
  disableNextButton = true;

  get GAME_END() {
    return "END";
  }

  get GAME_READY() {
    return "READY";
  }

  get GAME_PLAYING() {
    return "PLAYING";
  }

  get mute() {
    return this.$store.state.mute;
  }

  changeShowNextButton(val: boolean) {
    this.disableNextButton = val;
  }

  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    this.$refs.player?.reset();
    next();
  }

  mounted() {
    if (this.mute) {
      this.$refs.sounds.$refs.bgm.volume = 0;
    } else {
      this.$refs.sounds.$refs.bgm.volume = 0.05;
    }
    this.$nextTick(() => {
      window.setTimeout(() => {
        this.$refs.sounds.$refs.bgm.play();
      }, 100);
    });
    this.karutaData = shuffle(this.karutaData);
    console.log("ready");
    window.setTimeout(() => {
      console.log("start");
      this.playing = true;
      this.$refs.player.play(0);
      this.$refs.footer.startTimer();
    }, 3000);
  }

  playSE() {
    this.$refs.sounds.$refs.se.currentTime = 0;
    this.$refs.sounds.$refs.se.play();
  }

  onStop() {
    this.playing = false;
    this.$refs.player.reset();
    this.$router.push("/en/epilogue");
  }

  next() {
    this.$refs.player.next();
  }

  timeUp() {
    this.$router.push("/en/epilogue");
  }

  createKarutaProperty(no: number): Record<string, any> {
    const noString = no.toString().padStart(2, "0");
    const imgPath = `/sekisuikaruta/game/img/karuta/yomi_txt_${noString}/en_${noString}.svg`;
    const voicePath = `/sekisuikaruta/game/sounds/voices/en_${noString}.mp3`;
    const ku = `/sekisuikaruta/game/img/karuta/yomi_txt_${noString}/en_${noString}_a.svg`;
    const torifuda = [
      `/sekisuikaruta/game/img/karuta/tori_omote_${noString}.png`,
      `/sekisuikaruta/game/img/karuta/tori_ura_en_${noString}.png`,
    ];
    return {
      id: no,
      imgPath,
      voicePath,
      ku,
      torifuda,
    };
  }

  calcCharaHeight(srcHeight: number): string {
    return (srcHeight / 1080) * 100 + "%";
  }

  createStyle(
    path: string,
    srcHeight: number,
    args: Record<string, any>
  ): Record<string, any> {
    return {
      path,
      style: {
        ...args,
        height: this.calcCharaHeight(srcHeight),
      },
    };
  }
}
